var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35717 0.952393H5.64288C4.95911 0.952393 4.40479 1.50671 4.40479 2.19049V2.80954C4.40479 3.49331 4.95911 4.04763 5.64288 4.04763H9.35717C10.0409 4.04763 10.5953 3.49331 10.5953 2.80954V2.19049C10.5953 1.50671 10.0409 0.952393 9.35717 0.952393Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.38667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9048 2.19061H12.7619C13.0902 2.19061 13.4052 2.32106 13.6374 2.55324C13.8695 2.78543 14 3.10034 14 3.42871V15.8097C14 16.138 13.8695 16.453 13.6374 16.6851C13.4052 16.9173 13.0902 17.0478 12.7619 17.0478H2.2381C1.90973 17.0478 1.59482 16.9173 1.36263 16.6851C1.13045 16.453 1 16.138 1 15.8097V3.42871C1 3.10034 1.13045 2.78543 1.36263 2.55324C1.59482 2.32106 1.90973 2.19061 2.2381 2.19061H4.09524",
    stroke: "#EFFEF5",
    strokeWidth: 1.38667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0238 11.4762L6.88095 12.7143L10.5952 7.7619",
    stroke: "#EFFEF5",
    strokeWidth: 1.38667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskActive);
export default __webpack_public_path__ + "static/media/risk-active.c20ad3889afac63b2693696280d20b03.svg";
export { ForwardRef as ReactComponent };